<template>
    <ul class="nav steps text-left" :class="navClass">
      <li class="nav-item" v-for="step in steps" :class="[itemClass, {active: step.id == value}]">
        <a href="javascript:void(0)" class="nav-link" @click="changeStep(step.id)" v-html="step.title"></a>
      </li>
    </ul>
</template>
<script>
  export default {
    name: "step-nav",
    props: {
      navClass: {
        type: String,
        default: "",
        description: "Nav class"
      },
      itemClass: {
        type: String,
        default: "",
        description: "Nav item class"
      },
      steps: {
        type: [Object, Array],
        default: {},
        description: "Nav steps"
      },
      value: {
        type: String,
        default: "",
        description: "Active step"
      },
    },
    methods: {
      changeStep(id) {
        this.$emit('input', id)
      }
    }
  };
</script>
<style>
</style>
